import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useTheme } from "styled-components";

import { useUser } from "MVVM/Hooks/useUser";
import { useCs2HudSettingsModal } from "MVVM/Hooks/useClipQualitySettingsModal";
import { analytics } from "MVVM/Analytics";
import { NoticeBanner } from "../NoticeBanner";

const BANNER_HASH = "cs2-hud-crosshair";
const DISMISS_KEY = `banner-announcement-${BANNER_HASH}-has-been-closed`;
const PROMO = { type: "noticeBanner", promotionName: "cs2HudBanner" };

const AllstarClipsBanner = () => {
  const { allstarUser } = useUser();
  const history = useHistory();
  const theme = useTheme() as any;
  const { open: openCs2HudModal } = useCs2HudSettingsModal();
  const [shouldShow, setShouldShow] = useState(
    !localStorage.getItem(DISMISS_KEY),
  );

  const visible = shouldShow;

  useEffect(() => {
    if (visible) analytics.track("Promotion - Impression", PROMO);
  }, [visible]);

  if (!visible) return <></>;

  const onDismiss = (show: boolean) => {
    if (!show) analytics.track("Promotion - Dismiss", PROMO);
    setShouldShow(show);
  };

  // NoticeBanner spreads href onto a div, so navigate here instead.
  const onClick = () => {
    analytics.track("Promotion - Button Click", PROMO);
    if (allstarUser.loggedIn) {
      openCs2HudModal();
      return;
    }
    // Settings live in a modal, not a route, so send them back where they were.
    const next = encodeURIComponent(
      history.location.pathname + history.location.search,
    );
    history.push(`/login?next=${next}`);
  };

  return (
    <NoticeBanner
      hash={BANNER_HASH}
      backgroundColor={theme.colors.envy}
      display="flex"
      setShouldShow={onDismiss}
      onClick={onClick}
    >
      New! Customize your HUD and Crosshair on your Counter-Strike 2 clips.
    </NoticeBanner>
  );
};

export { AllstarClipsBanner };
